// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
import { Link } from "react-router-dom";
/** @jsx jsx */ import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import classnames from "classnames";

import {
  // Import Const
  colors,
  sizes,
  // Import Functions
  typeSet,
  uppercase,
  padding,
  expandValue,
  breakpoints,
  transition
} from "../../helpers/theme";

const navStyles = props => css`
  position: absolute;
  top: 0;
  right: 0;
  color: ${colors.white};
  height: ${expandValue(sizes.space * 3)};
  padding: 0 ${expandValue(sizes.space)};
  width: 100%;
  ${typeSet()};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  a.nav-link {
    pointer-events: all;
    ${typeSet(sizes.fontSize)}
    ${uppercase()};
    ${transition("all", sizes.timer + "ms")}
    ${padding(
      "all",
      expandValue((sizes.space + sizes.cap) * 0.5) +
        " 0 " +
        expandValue((sizes.space - sizes.cap) * 0.5)
    )}
    height: 100%;
    color: ${colors.white};
    text-decoration: none;
    display: inline-block;
    margin: 0 ${expandValue(sizes.space * 0.5)};
    font-weight: 300;
    position: relative;
    display: flex;
    align-items: center;
    &.home {
      font-weight: 800;
    }
    &:before {
      ${transition("all", sizes.timer + "ms")}
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      right: 100%;
      height: ${expandValue(sizes.space * 0.125)};
      background: ${colors.white};
    }
    &.active {
      &:before {
        right: 0;
      }
    }
    &:hover {
      &:before {
        right: 0;
      }
    }
  }
  transition: height ${
    sizes.timer
  }ms cubic-bezier(0.2, 0.53, 0.55, 0.86), transform ${
  sizes.timer
}ms cubic-bezier(0.2, 0.53, 0.55, 0.86), background ${
  sizes.timer
}ms cubic-bezier(0.2, 0.53, 0.55, 0.86);
  transition-delay: ${sizes.timer}ms;
  &.Banished {
    height: ${expandValue(sizes.space * 3)};
    transform: translateY(-100%);
    will-change: transform, height, background;
  }
  &.Chill {
    will-change: transform, height, background;
    height: ${expandValue(sizes.space * 3)};
    a.nav-link.active:before,
    a.nav-link:hover:before {
      height: ${expandValue(sizes.space * 0.125)};
    }
  }
  @media (min-width: ${expandValue(breakpoints[3])}) {
    height: ${expandValue(sizes.space * 6)};
    padding: 0 ${expandValue(sizes.space)};
    a.nav-link {
      ${typeSet(sizes.fontSize)}
      margin: 0 ${expandValue(sizes.space)};
    }
  }
`;
const NavStyled = styled("nav")`
  ${navStyles}
`;

export class PrimaryNav extends React.Component {
  render() {
    return (
      <NavStyled id="Nav" className="primary-nav" role="navigation">
        <Link
          to="/"
          className={classnames("nav-link", {
            active: window.location.pathname === "/"
          })}
        >
          Work
        </Link>
        <Link
          to="/resume"
          className={classnames("nav-link", {
            active: window.location.pathname === "/resume"
          })}
        >
          Resume
        </Link>
        <Link
          to="/contact"
          className={classnames("nav-link", {
            active: window.location.pathname === "/contact"
          })}
        >
          Contact
        </Link>
      </NavStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PrimaryNav/PrimaryNav.js